export enum Routes {
  Cancel = 'user/deactivate',
  // OfferingsCancelPatch is used for the new "OES Source Of Truth" cancel account
  OfferingsCancelPatch = 'accounts/offerings/cancel',
}
